export default "__VITE_ASSET__MbHKATVf__"